import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class EstateSignUpFinancialAdvisorMeta extends BaseEntityModel {
  parentId?: number;
  requiresProfessionSelection?: boolean;

  constructor(model: Partial<EstateSignUpFinancialAdvisorMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.requiresProfessionSelection = model.requiresProfessionSelection;
  }
}
